/**
 * Component - reviewList
 */

export const reviewList = ():void => {
  // Run the script for each individual component found on the page
  const componentSelector = document.querySelectorAll('.js-reviewList') as unknown as HTMLElement[]
  componentSelector.forEach((component:HTMLElement) => {
    const sliderWrapper = component.querySelector('.js-reviewList-slider') as unknown as HTMLElement
    if (sliderWrapper === null) {
      return
    }

    const sliderItems = sliderWrapper.querySelectorAll('.js-reviewList-sliderItem') as unknown as HTMLElement[]
    if (sliderItems.length === 0) {
      return
    }

    new window.Swiper(sliderWrapper, {
      slidesPerView: 'auto',
      spaceBetween: 0,
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      }
    })
  })
}
